export enum BookingStatus {
    Cancelled = 0,
    Booked = 1,
    BookedWaitlist = 2,
    BookedWaitlistLate = 3,
    Wait = 4,
    LateCancellation = 5,
    NoShow = 6,
    Hold = 7
}